import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { SelectBoxOption } from '../../stores/SelectBoxStore';
import { UIHelper } from '../../utils/UIHelper';

export interface BasePopupMenuOptionProps extends SelectBoxOption {
    active: boolean;
    first?: boolean;
    optionClick?: (pValue: string | number) => void;
}

export class BasePopupMenuOption extends BaseComponent<BasePopupMenuOptionProps, {}> {
    public render(): JSX.Element {
        let tClass: string = 'egr-select-option';
        if (this.props.className) {
            tClass += ' ' + this.props.className.toString();
        }
        if (this.props.name === 'separator') {
            return (
                <div className={tClass}/>
            );
        }
        if (this.props.active) {
            tClass += ' egr-select-option-active';
        }
        if (this.props.disabled) {
            tClass += ' egr-select-option-disabled';
        }
        if (this.props.first) {
            tClass += ' egr-select-option-firstentry';
        }
        if (this.props.callback) {
            if (this.props.disabled) {
                return (
                    <div className={tClass}>
                        <span>{this.props.name}</span>
                        {this.props.extraButtons}
                    </div>
                );
            }
            return (
                <div onClick={this.props.callback} className={tClass}>
                    <span>{this.props.name}</span>
                    {this.props.extraButtons}
                </div>
            );
        }
        return (
            <div onClick={this.onClick} className={tClass}>
                <span>{this.props.name}</span>
                {this.props.extraButtons}
            </div>
        );
    }

    protected onClick = (event: React.MouseEvent): void => {
        UIHelper.stopEvent(event);
        if (this.props.optionClick != null) {
            this.props.optionClick(this.props.value);
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/BasePopupMenuOption.tsx